var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ChartLayout',{attrs:{"title":"عدد المواعيد حسب الاطباء "}},[_c('BarChart',{attrs:{"chart-data":_vm.appointmentsByDoctor,"height":150}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }